import { render, staticRenderFns } from "./FieldTypeDetail.vue?vue&type=template&id=b73cb500"
import script from "./FieldTypeDetail.vue?vue&type=script&lang=js"
export * from "./FieldTypeDetail.vue?vue&type=script&lang=js"
import style0 from "./FieldTypeDetail.vue?vue&type=style&index=0&id=b73cb500&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports